var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',_vm._l((_vm.columns),function(column,idx){return _c('col',{key:idx,style:({ width: column.width }),attrs:{"name":("col_" + (idx + 1))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }